'use client';
import { useTrackPage } from '../../reporter'; // Client-side tracking hook

const TrackPageClient = ({ taggingPrefix }) => {
  useTrackPage(taggingPrefix);

  return null;
};

export default TrackPageClient;
